import ProviderProfileSource from '$provider/models/ProviderProfileSource';
import type { ProviderProfileImportModel } from '$provider/models/profile/ProviderProfileImportModel';
import type { CaqhDocument } from '$provider/models/profile/caqh/CaqhDocument';
import type { CaqhProviderProfileModel } from '$provider/models/profile/caqh/CaqhProviderProfileModel';

class CaqhDocumentData {
  private documents: Map<string, CaqhDocument> = new Map();

  public getInfo(id: string): CaqhDocument | undefined {
    return this.documents.get(id);
  }

  public storeDocuments(profileImports: ProviderProfileImportModel[]): void {
    if (!Array.isArray(profileImports)) return;

    profileImports.forEach((importData: ProviderProfileImportModel) => {
      if (![ProviderProfileSource.Caqh, ProviderProfileSource.CaqhPo].includes(importData.source))
        return;

      const profile = importData.profile as CaqhProviderProfileModel;

      profile?.documentInformation?.documents?.forEach((document: CaqhDocument) => {
        document?.download?.fileId && this.documents.set(document?.download?.fileId, document);
      });
    });
  }

  public reset(): void {
    this.documents.clear();
  }
}

export const caqhDocumentData = new CaqhDocumentData();
